import { useContext } from "react";
import ExpressionEvaluatorContext from "../Contexts/ExpressionEvaluatorContext";
import { IExpressionEvaluatorContext } from "../Models/IExpressionEvaluatorContext";

/**
 * Convenience hook for accessing the ExpressionEvaluatorContext
 * This is a wrapper over useContext(ExpressionEvaluatorContext)
 */
export function useExpressionEvaluatorContext(): IExpressionEvaluatorContext {
  const context = useContext(ExpressionEvaluatorContext);

  if (context === undefined) {
    throw new Error("useExpressionEvaluatorContext must be used within an ExpressionEvaluatorContextProvider");
  }

  return context;
}
